import { mutator } from 'satcheljs';
import saveSigningCertificate from '../actions/saveSigningCertificate';

/**
 * Mutator that saves the signing certificate raw data in compose view state
 */
export default mutator(saveSigningCertificate, actionMessage => {
    const { smimeViewState, signingCertRawData } = actionMessage;
    smimeViewState.signingCertRawData = signingCertRawData;
});
